import script from "./ContentFileSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentFileSummary.vue?vue&type=script&setup=true&lang=ts"

import "./ContentFileSummary.vue?vue&type=style&index=0&id=86c3738e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86c3738e"]])

export default __exports__